import BrandDesign from "./Components/DesignService/BrandDesign"
import CTA from "./Components/CTA"
import DatabaseDesign from "./Components/DesignService/DatabaseDesign"
import Header from "./Components/DesignService/Header"
import InterfaceDesign from "./Components/DesignService/InterfaceDesign"
import SystemDesign from "./Components/DesignService/SystemDesign"

const Design = () => {
    return (
        <div className="select-none">
            <Header></Header>
            <BrandDesign></BrandDesign>
            <InterfaceDesign></InterfaceDesign>
            <SystemDesign></SystemDesign>
            {/* <DatabaseDesign></DatabaseDesign> */}
            <CTA></CTA>
        </div>
    )
}

export default Design